module.exports = __webpack_public_path__ + "img/drone_03_H.d0dd1eee.webp";